var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common';
import { VendorAuthorityDto } from './vendor-authority.dto';
export class VendorWithoutRelationsDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.type = initializer.type;
        this.managerName = initializer.managerName;
        this.phoneNumber1 = initializer.phoneNumber1;
        this.phoneNumber2 = initializer.phoneNumber2;
        this.fax = initializer.fax;
        this.email = initializer.email;
        this.commission1 = initializer.commission1;
        this.commission2 = initializer.commission2;
        this.insuranceGrade = initializer.insuranceGrade;
        this.authority = initializer.authority;
        this.rate = initializer.rate;
        this.memo = initializer.memo;
        this.feeGradeId = initializer.feeGradeId;
    }
}
__decorate([
    Type(() => VendorAuthorityDto),
    __metadata("design:type", VendorAuthorityDto)
], VendorWithoutRelationsDto.prototype, "authority", void 0);
